import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { useEffect, useRef, useState } from "react";
import RoundButton from "../RoundButton";
import styles from "./style.module.css";
import { MdOutlineKeyboardDoubleArrowDown, MdOutlineKeyboardDoubleArrowUp } from "react-icons/md";
function Clock({ freeStyle, time, initRapidValue, funcs, playStateFromAbove }) {
  const [play, setPlay] = useState(false);
  const [isplay, setIsPlay] = useState(false);
  let timeInSeconds = time;
  const [rapidValue, setRapidValue] = useState(initRapidValue);
  const [isFinish, setIsFinish] = useState(false);

  const intervalRef = useRef(null);

  function complete() {
    setIsFinish(true);
    funcs.onComplete();
  }

  useEffect(() => {
    if (!playStateFromAbove) {
      setIsPlay(false);
      setPlay(false);
    } else {
      if (freeStyle) {
        setIsPlay(true);
      }
    }
  }, [playStateFromAbove]);

  const handleIncrease = () => {
    let newRapidValue = Math.min(rapidValue + 1, 100);
    setRapidValue((prev) => newRapidValue);
    if (freeStyle != 1) {

      funcs.rapid(newRapidValue);
      if (!isplay) {
        funcs.onPlay();
      }

    }
  };

  const handleDecrease = () => {
    let newRapidValue = Math.max(rapidValue - 1, 1)
    setRapidValue((prev) => newRapidValue);
    if (freeStyle != 1) {
      funcs.rapid(newRapidValue);
      if (!isplay) {
        funcs.onPlay();
      }
    }
  };

  const handleMouseDown = (changeValue) => {
    if (freeStyle == 1) {

      intervalRef.current = setTimeout(() => {
        intervalRef.current = setInterval(() => {
          setRapidValue((prev) => {
            const newValue = prev + changeValue;
            return newValue < 1 ? 1 : newValue > 99 ? 100 : newValue;
          });
        }, 100);
      }, 500);
    }
  };

  const handleMouseUp = () => {
    if (freeStyle == 1) {

      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        clearTimeout(intervalRef.current); // Clear the timeout as well
        intervalRef.current = null;
      }
      funcs.rapid(rapidValue); // Notify the external function about the rapid value change
    }
  };

  const renderTime = ({ remainingTime }) => {
    const minutes = Math.floor(remainingTime / 60);
    const seconds = remainingTime - minutes * 60;

    return (
      <div className={styles["wrapping"]}>
        <div className={styles["timer"]}>
          {freeStyle ? (
            <button className={styles["squareButton"]}>
              <div className={styles["rapid"]}>{rapidValue}</div>
              <br />LPM
            </button>
          ) : (
            <div className={styles["value"]}>
              {minutes < 10 && 0}
              {minutes}:{seconds < 10 && 0}
              {seconds}
            </div>
          )}
          {remainingTime === 0 && complete()}
          {!isFinish && (
            <div
              className={styles["playPause"]}
              onClick={() => {
                !freeStyle && setPlay(!play);
                !isplay && funcs.onPlay();
                isplay && funcs.onPause();
              }}
            >
              <RoundButton setIsPlay={setIsPlay} isPlay={isplay} />
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      {(freeStyle == 1 || !freeStyle) ?
        (<div className={styles["wrapClock"]}>
          {freeStyle && (
            <button
              className={styles["plusMinus"]}
              onClick={handleDecrease}
              onMouseDown={() => handleMouseDown(-1)}
              onMouseUp={handleMouseUp}
              onTouchStart={() => handleMouseDown(-1)}
              onTouchEnd={handleMouseUp}
            >
              -
            </button>
          )}
          <div>
            <CountdownCircleTimer
              rotation={"counterclockwise"}
              isPlaying={play}
              duration={timeInSeconds}
              colors={["#7D56A5"]}
              onComplete={() => ({ shouldRepeat: false, delay: 1 })}
              trailColor={"#FEEFEC"}
              strokeLinecap={"square"}
              size={200}
              strokeWidth={15}
            >
              {renderTime}
            </CountdownCircleTimer>
          </div>
          {freeStyle && (
            <button
              className={styles["plusMinus"]}
              onClick={handleIncrease}
              onMouseDown={() => handleMouseDown(1)}
              onMouseUp={handleMouseUp}
              onTouchStart={() => handleMouseDown(1)}
              onTouchEnd={handleMouseUp}
            >
              +
            </button>
          )}

        </div>)
        :
        <>
          <div className={styles["wrapClock"]}>
            <div>
              <CountdownCircleTimer
                rotation={"counterclockwise"}
                isPlaying={play}
                duration={timeInSeconds}
                colors={["#7D56A5"]}
                onComplete={() => ({ shouldRepeat: false, delay: 1 })}
                trailColor={"#FEEFEC"}
                strokeLinecap={"square"}
                size={200}
                strokeWidth={15}
              >
                {renderTime}
              </CountdownCircleTimer>
            </div>

          </div>
          <div
            className={styles["btn-container"]}

          >
            {freeStyle && (
              <button
                className={styles["lowerFasterBtn"]}
                onClick={handleIncrease}
                onMouseDown={() => handleMouseDown(1)}
                onMouseUp={handleMouseUp}
                onTouchStart={() => handleMouseDown(1)}
                onTouchEnd={handleMouseUp}
              >
                <div className={styles["icon"]}>
                  <MdOutlineKeyboardDoubleArrowUp />
                </div>
                Faster
              </button>
            )}

            {freeStyle && (
              <button
                className={styles["lowerFasterBtn"]}
                onClick={handleDecrease}
                onMouseDown={() => handleMouseDown(-1)}
                onMouseUp={handleMouseUp}
                onTouchStart={() => handleMouseDown(-1)}
                onTouchEnd={handleMouseUp}
              >
                <div className={styles["icon"]}>

                  <MdOutlineKeyboardDoubleArrowDown scale={1.5} />
                </div>
                Slower
              </button>
            )}
          </div>
        </>



      }
    </>
  );
}

export default Clock;
